import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import AzureAPIService, { setAzureAuthToken } from "./AzureAPIService";
import DebugService from "./DebugService";

/**
 * @description Global Scan Api Service
 */
const GlobalScanApiService = {

  scanAccount: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_GLOBAL_SCAN
      let dataRequest = {}

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          dataRequest['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          dataRequest['userId'] = parseToJson['userId']
        }
      }

      return await APIService.post(url, dataRequest)
    } catch (err) {
      DebugService.error(`Global Scan Api Service: Error Caught while scanning account`, err)
    }
  },

  getScanResult: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_GLOBAL_SCAN_RESULT

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          url += `?userAccountId=${selectedAccount}`
        }

        if (parseToJson['userId']) {
          url += `&userId=${parseToJson['userId']}`
        }
      }

      return await APIService.get(url)
      // try {
      //   const response = await axios.get(`${process.env.REACT_APP_API_BASE_STAGING_URL}/${url}`);
      //   return response.data;
      // } catch (error) {
      //   DebugService.error(`Error making GET request to ${url}:`, error);
      //   throw error;
      // }
    } catch (err) {
      DebugService.error(`Global Scan Api Service: Error Caught while fetching scanned result`, err)
    }
  },

  getScanParsedResult: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_GLOBAL_SCAN_PARSED_RESULT

      return await APIService.post(url, data)
      // try {
      //   const response = await axios.post(`${process.env.REACT_APP_API_BASE_STAGING_URL}/${url}`, data);

      //   if (response.status !== 200) {
      //     throw new Error('Caught error while saving details..', response)
      //   }

      //   return response.data;
      // } catch (error) {
      //   DebugService.error(`Error making POST request to ${url}:`, error);
      //   throw error;
      // }
    } catch (err) {
      DebugService.error(`Global Scan Api Service: Error Caught while fetching scanned parsed result`, err)
    }
  },

  // ==============================================
  // Azure APIs
  // ==============================================
  scanAzureAccount: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_GLOBAL_SCAN
      let dataRequest = {}

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          dataRequest['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          dataRequest['userId'] = parseToJson['userId']
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, dataRequest)
    } catch (err) {
      DebugService.error(`Global Scan Api Service: Error Caught while scanning account`, err)
    }
  },

  getAzureScanResult: async (selectedAccount) => {
    try {
      let url = APIConstants.ENDPOINT_GLOBAL_SCAN_RESULT

      const data = {}

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          // url += `?userAccountId=${selectedAccount}`
          data['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          // url += `&userId=${parseToJson['userId']}`
          data['userId'] = parseToJson['userId']
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, data)

    } catch (err) {
      DebugService.error(`Global Scan Api Service: Error Caught while fetching scanned result`, err)
    }
  },

  getAzureScanParsedResult: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_GLOBAL_SCAN_PARSED_RESULT

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, data)

    } catch (err) {
      DebugService.error(`Global Scan Api Service: Error Caught while fetching scanned parsed result`, err)
    }
  },
}

export default GlobalScanApiService;
